<template>
<div>
  <b-tabs card>
    <b-tab title="Design" name="design" :active="activeName === 'design'">
      <home :formType="formType"/>
    </b-tab>
    <b-tab title="Preview" name="preview" :active="activeName === 'preview'">
      <preview :formType="formType"/>
    </b-tab>
    <b-tab title="Form Button Visibility" name="formButton" :active="activeName === 'formButton'">
      <ButtonSettings :formType="formType"/>
    </b-tab>

  </b-tabs>
</div>
</template>

<script>
import Home from '@/views/Home';
import Preview from '@/views/Preview';
import ButtonSettings from '@/views/ButtonSettings';

export default {
  store: ['forms', 'sections', 'fields', 'baseFields', 'lists', 'validators', 'conditioners', 'formButton'],
  props: [
    'templateSections',
    'templateFields',
    'formDefinition',
    'formButtonDefinition',
    'baseFieldsFromConfig',
    'availableLists',
    'availableValidators',
    'conditioningFields',
    'formType',
  ],

  mounted () {
    this.forms = this.padFormDefinitionWithSectionSpans(this.formDefinition)
    this.formButton = this.formButtonDefinition
    this.sections = this.templateSections
    this.fields = this.templateFields
    this.baseFields = this.baseFieldsFromConfig
    this.lists = this.availableLists
    this.validators = this.availableValidators
    this.conditioners = this.conditioningFields
  },

  methods: {
    padFormDefinitionWithSectionSpans(formDefinition) {
      return formDefinition.map(section => {
        if ('span' in section) {
          return section
        }

        section.span = 12

        return section
      })
    }
  },

  data() {
    return {
      activeName: "Design"
    }
  },
  components: {
    Home,
    Preview,
    ButtonSettings,
  }
}
</script>
